import * as React from 'react';
import { SVGProps } from 'react';

const IconSelectSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 8.5 10 4H2l4 4.5z" />
  </svg>
);

export default IconSelectSizeXs;
